import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocalStorage } from "@uidotdev/usehooks";
import { Button, Grid } from "@mui/material";

const Question = ({ onQuestionsAdded, questionType }) => {
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useLocalStorage("token", null);
  const [selectedFile, setSelectedFile] = useState(null);
  const inputRef = useRef(null);

  const handleAdd = async () => {
    try {
      const formData = new FormData();
      formData.append("excelFile", selectedFile);
      formData.append("questionType", questionType);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/exercise/add`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const insertedQuestionIds = response.data.insertedQuestionIds;
      onQuestionsAdded(insertedQuestionIds);

      toast.success("Questions added successfully");
    } catch (error) {
      console.error("Error adding questions:", error);
      toast.error(`Error adding questions: ${error.message}`);
    }
  };

  const handleUpdate = async () => {
    try {
      const formData = new FormData();
      formData.append("excelFile", selectedFile);

      await axios.put(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/exercise/update`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const insertedQuestionIds = [];
      console.log("Questions updated successfully");
      onQuestionsAdded(insertedQuestionIds);

      toast.success("Questions updated successfully");
    } catch (error) {
      console.error("Error updating questions:", error);
      toast.error(`Error updating questions: ${error.message}`);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  return (
    <Grid
      xs={12}
      container
      justifyContent={"space-between"}
      direction={"column"}
    >
      <Grid>
        <input
          ref={inputRef}
          style={{ display: "none" }}
          type="file"
          id="file-upload"
          onChange={handleFileChange}
        />
        <button
          style={{
            width: "100%",
            backgroundColor: "transparent",
            border:"none",
            color:"#838181",
            borderRadius:"4px",
            boxShadow:
              "0px 1.74px 3.48px 0px #0000001A inset,0px -1.74px 3.8px 0px #C8C7C740 inset,0px 1.74px 3.48px 0px #0000001A",
          }}
          onClick={() => {
            inputRef.current.click();
          }}
        >
          Choose File
        </button>
      </Grid>
      <Grid>
        <label style={{width:"100%",textAlign:"center"}}>{selectedFile ? selectedFile.name : "No File Selected"}</label>
      </Grid>
      <div>
        <Button onClick={handleAdd} className="filled-button mr-2">
          Add Questions
        </Button>
        <Button onClick={handleUpdate} className="filled-button">
          Update Questions
        </Button>
      </div>
    </Grid>
  );
};

export default Question;
